module.exports = __webpack_public_path__ + "static/media/appstore-btn.78099974.svg";